var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var RemoveDepartmentLabelsDropdownController = (function () {
    function RemoveDepartmentLabelsDropdownController($uibModal) {
        this.$uibModal = $uibModal;
    }
    RemoveDepartmentLabelsDropdownController.prototype.createAvailableActions = function () {
        var _this = this;
        if (!this.players.length || !this.availableLabels.length || !this.selectedLabel) {
            return (this.actions = null);
        }
        var availableLabelsForRemove = this.availableLabels.filter(function (label) { return label._id === _this.selectedLabel._id; });
        this.actions = availableLabelsForRemove.map(function (label) {
            return { initial: true, desired: true, label: label };
        });
    };
    RemoveDepartmentLabelsDropdownController.prototype.changeAction = function (event, action) {
        switch (action.desired) {
            case true:
                action.desired = false;
                break;
            case false:
                action.desired = true;
                break;
        }
        event.preventDefault();
    };
    Object.defineProperty(RemoveDepartmentLabelsDropdownController.prototype, "isApplyPossible", {
        get: function () {
            return (this.actions || []).some(function (item) { return item.desired !== item.initial; });
        },
        enumerable: false,
        configurable: true
    });
    RemoveDepartmentLabelsDropdownController.prototype.apply = function () {
        return __awaiter(this, void 0, void 0, function () {
            var confirmationText, modalTitle, playerCount, playersWithLists, playersToRemove, hasPlayersToRemove_1, playersToRemoveHtml, playersToRemoveHtml, modalInstance, result, changes, _e_1, labelName, playerCount, modalInstance, result, changes, _e_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        modalTitle = 'Confirm Removal';
                        if (!!this.selectedLabel) return [3, 5];
                        modalTitle = 'Remove players from Scouting Department';
                        playerCount = this.players.length;
                        playersWithLists = this.players.filter(function (player) { return player.labels.length > 1 || player.labels.some(function (label) { return label.label; }); });
                        playersToRemove = this.players.filter(function (player) { return !(player.labels.length > 1 || player.labels.some(function (label) { return label.label; })); });
                        hasPlayersToRemove_1 = playersToRemove.length > 0;
                        if (playersWithLists.length > 0) {
                            playersToRemoveHtml = playersToRemove.length > 0
                                ? playersToRemove
                                    .map(function (player) { return "<li>".concat(player.player.firstName, " ").concat(player.player.lastName, "</li>"); })
                                    .join('')
                                : '';
                            confirmationText = "\n          <div>\n            \n            \n            ".concat(playersToRemove.length > 0
                                ? "\n              <strong>".concat(playersToRemove.length, " player(s) will be removed from the Scouting Department:</strong>\n              <div class=\"modal-scrollable-list\" style=\"margin-bottom: 10px;\">\n                <ul style=\"margin-bottom: 0;\">\n                  ").concat(playersToRemoveHtml, "\n                </ul>\n              </div>\n              <strong class=\"bold\">Important: ").concat(playersWithLists.length, " of ").concat(playerCount, " selected player(s) can't be removed because they are assigned to a list.</strong>\n            ")
                                : "<strong class=\"text-danger\">All selected players are still assigned to a list.\n                Remove them from the list before removing them from the Scouting Department.</strong>", "\n          </div>\n        ");
                        }
                        else {
                            playersToRemoveHtml = playersToRemove
                                .map(function (player) { return "<li>".concat(player.player.firstName, " ").concat(player.player.lastName, "</li>"); })
                                .join('');
                            confirmationText = "\n          <div>\n            <strong>".concat(playerCount, " player(s) will be removed from the Scouting Department:</strong>\n            <div class=\"modal-scrollable-list\">\n              <ul style=\"margin-bottom: 0;\">\n                ").concat(playersToRemoveHtml, "\n              </ul>\n            </div>\n          </div>\n        ");
                        }
                        modalInstance = this.$uibModal.open({
                            size: 'md',
                            resolve: {
                                noPlayersToRemove: function () { return !hasPlayersToRemove_1; },
                            },
                            template: "\n          <div class=\"sc-modal\">\n            <div class=\"modal-header\">\n              <h3 class=\"modal-title\">".concat(modalTitle, "</h3>\n            </div>\n            <div class=\"modal-body md-body-1\">\n              ").concat(confirmationText, "\n            </div>\n            <div class=\"modal-footer\">\n              <div layout layout-align=\"space-between center\" class=\"m-n\">\n                <md-button class=\"md-raised\" ng-click=\"$ctrl.cancel()\">\n                  CANCEL\n                </md-button>\n                <md-button \n                  class=\"md-primary md-raised\" \n                  ng-click=\"$ctrl.confirm()\"\n                  ng-disabled=\"$ctrl.noPlayersToRemove\"\n                  title=\"{{$ctrl.noPlayersToRemove ? 'All selected players belong to lists. Nothing to remove with this action.' : ''}}\"\n                >\n                  REMOVE\n                </md-button>\n              </div>\n            </div>\n          </div>\n        "),
                            controller: [
                                '$uibModalInstance',
                                'noPlayersToRemove',
                                function ($uibModalInstance, noPlayersToRemove) {
                                    this.modalInstance = $uibModalInstance;
                                    this.noPlayersToRemove = noPlayersToRemove;
                                    this.cancel = function () {
                                        $uibModalInstance.dismiss('cancel');
                                    };
                                    this.confirm = function () {
                                        $uibModalInstance.close('confirm');
                                    };
                                },
                            ],
                            controllerAs: '$ctrl',
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, modalInstance.result];
                    case 2:
                        result = _a.sent();
                        if (result === 'confirm') {
                            changes = playersToRemove.flatMap(function (player) {
                                return player.labels.map(function (label) {
                                    return { type: 'remove', player: player, label: label._id };
                                });
                            });
                            this.onChange({ $changes: changes });
                        }
                        return [3, 4];
                    case 3:
                        _e_1 = _a.sent();
                        return [3, 4];
                    case 4: return [3, 9];
                    case 5:
                        labelName = this.selectedLabel.label.name;
                        playerCount = this.players.length;
                        modalTitle = 'Remove from List';
                        confirmationText = "\n        <div>\n          <strong>".concat(playerCount, " player(s) will be removed from the \"").concat(labelName, "\" list:</strong>\n          <div class=\"modal-scrollable-list\">\n            <ul style=\"margin-bottom: 0;\">\n              ").concat(this.players
                            .map(function (player) { return "<li>".concat(player.player.firstName, " ").concat(player.player.lastName, "</li>"); })
                            .join(''), "\n            </ul>\n          </div>\n        </div>\n      ");
                        modalInstance = this.$uibModal.open({
                            size: 'md',
                            template: "\n          <div class=\"sc-modal\">\n            <div class=\"modal-header\">\n              <h3 class=\"modal-title\">".concat(modalTitle, "</h3>\n            </div>\n            <div class=\"modal-body md-body-1\">\n              ").concat(confirmationText, "\n            </div>\n            <div class=\"modal-footer\">\n              <div layout layout-align=\"space-between center\" class=\"m-n\">\n                <md-button class=\"md-raised\" ng-click=\"$ctrl.cancel()\">\n                  CANCEL\n                </md-button>\n                <md-button class=\"md-primary md-raised\" ng-click=\"$ctrl.confirm()\">\n                  REMOVE\n                </md-button>\n              </div>\n            </div>\n          </div>\n        "),
                            controller: [
                                '$uibModalInstance',
                                function ($uibModalInstance) {
                                    this.modalInstance = $uibModalInstance;
                                    this.cancel = function () {
                                        $uibModalInstance.dismiss('cancel');
                                    };
                                    this.confirm = function () {
                                        $uibModalInstance.close('confirm');
                                    };
                                },
                            ],
                            controllerAs: '$ctrl',
                        });
                        _a.label = 6;
                    case 6:
                        _a.trys.push([6, 8, , 9]);
                        return [4, modalInstance.result];
                    case 7:
                        result = _a.sent();
                        if (result === 'confirm') {
                            changes = this.players.map(function (player) {
                                return {
                                    type: 'remove',
                                    player: player,
                                    label: _this.selectedLabel._id || null,
                                };
                            });
                            this.onChange({ $changes: changes });
                        }
                        return [3, 9];
                    case 8:
                        _e_2 = _a.sent();
                        return [3, 9];
                    case 9: return [2];
                }
            });
        });
    };
    return RemoveDepartmentLabelsDropdownController;
}());
angular.module('app.scouting').component('scoutingRemoveDepartmentLabelsDropdown', {
    templateUrl: 'scouting/components/remove-department-labels-dropdown.html',
    controller: RemoveDepartmentLabelsDropdownController,
    bindings: { players: '<', availableLabels: '<', selectedLabel: '<', onChange: '&' },
});